import { render, staticRenderFns } from "./telecomSsoLogin.vue?vue&type=template&id=1ea3fb1b&scoped=true"
import script from "./telecomSsoLogin.vue?vue&type=script&lang=js"
export * from "./telecomSsoLogin.vue?vue&type=script&lang=js"
import style0 from "./telecomSsoLogin.vue?vue&type=style&index=0&id=1ea3fb1b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea3fb1b",
  null
  
)

export default component.exports